import {
  GET_HOLDINGS_FOR_FUND_REQUEST,
  GET_HOLDINGS_FOR_FUND_SUCCESS,
  GET_HOLDINGS_FOR_FUND_FAILURE,
  statusType
} from '../../../actions'

const initial = {
  data: [],
  total: 0,
  status: statusType.IDLE
}

const fundCurrentHoldingsReducer = (state = initial, action) => {
  switch (action.type) {
    case GET_HOLDINGS_FOR_FUND_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }
    case GET_HOLDINGS_FOR_FUND_SUCCESS:
      return {
        ...state,
        data: action.payload,
        total: action.meta.total,
        status: statusType.SUCCESS
      }
    case GET_HOLDINGS_FOR_FUND_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }
    default:
      return state
  }
}

export default fundCurrentHoldingsReducer
